import React, { useState, useEffect } from 'react';
import api from '../api';

export default function EinstellungenPage() {
  const [kategorien, setKategorien] = useState([]);
  const [form, setForm] = useState({ name: '', icon: '📦', farbe: '#6366f1' });

  useEffect(() => { laden(); }, []);
  async function laden() { const r = await api.get('/kategorien'); setKategorien(r.data); }
  async function erstellen(e) {
    e.preventDefault();
    await api.post('/kategorien', form);
    setForm({ name: '', icon: '📦', farbe: '#6366f1' });
    laden();
  }
  async function loeschen(id) { await api.delete(`/kategorien/${id}`); laden(); }

  const inp = { padding: '10px 14px', border: '1px solid #e2e8f0', borderRadius: '10px', fontSize: '14px' };

  return (
    <div>
      <h1 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '20px' }}>⚙️ Einstellungen</h1>
      <div style={{ background: 'white', borderRadius: '14px', padding: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
        <h3 style={{ margin: '0 0 12px', fontSize: '15px' }}>🏷️ Kategorien</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '16px' }}>
          {kategorien.map(k => (
            <div key={k.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: '#f8fafc', borderRadius: '8px' }}>
              <span>{k.icon}</span>
              <span style={{ flex: 1, fontWeight: '600', fontSize: '14px' }}>{k.name}</span>
              <div style={{ width: '14px', height: '14px', borderRadius: '50%', background: k.farbe }} />
              <button onClick={() => loeschen(k.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444' }}>🗑️</button>
            </div>
          ))}
        </div>
        <form onSubmit={erstellen} style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <input style={{ ...inp, flex: 1, minWidth: '120px' }} placeholder="Name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
          <input style={{ ...inp, width: '60px' }} placeholder="Icon" value={form.icon} onChange={e => setForm({...form, icon: e.target.value})} />
          <input type="color" value={form.farbe} onChange={e => setForm({...form, farbe: e.target.value})} style={{ width: '44px', padding: '4px', border: 'none', borderRadius: '8px' }} />
          <button type="submit" style={{ padding: '10px 16px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}>+</button>
        </form>
      </div>
    </div>
  );
}
